import React from 'react';
import './testimonials.css';
import Victor from '../../assets/Victor.png'
import freke from '../../assets/freke.jpeg'
import Tonia from '../../assets/Tonia.jpeg'

import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';




const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper className='container testimonials__container'
      modules={[ Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      pagination={{ clickable: true }} 
      >
        <SwiperSlide className='testimonial'>
          <div className="client__avatar">
            <img src={Victor} alt="Person one"/>
          </div>
            <h5 className='client__name'>Director of Media Operations, Rifi Foods</h5>
            <small className='client__review'>
            I highly recommend Chuks Chito for their exceptional web development services. They delivered our website for Rifi Food Industries with precision and on time. Chuks Chito demonstrated professionalism, technical expertise, and a keen eye for detail throughout the project. The website they built is visually appealing, user-friendly, and performs seamlessly across devices and browsers. They actively sought feedback, making necessary adjustments promptly. I wholeheartedly endorse Chuks Chito for their dedication and commitment to client satisfaction.
            For further information, please contact me at ogbogbovictor@gmail.com.


            </small>
        </SwiperSlide>
        <SwiperSlide className='testimonial'>
          <div className="client__avatar">
            <img src={freke} alt="person two"/>
          </div>
            <h5 className='client__name'>Gomycode Instructor, Full-stack Javascript developer</h5>
            <small className='client__review'>
            I highly recommend Chuks Chito for her exceptional work on the full-stack development of a pizza e-commerce app showcased during our demo-day. Her work was excellent and seamless.
            Chuks Chito demonstrated impressive technical skills and attention to detail throughout the project. The app's functionality, user experience, and visual design were outstanding. She seamlessly integrated various technologies and frameworks, resulting in a robust and scalable application.
            During the demo-day presentation, Chuks Chito confidently showcased her deep knowledge and effectively communicated complex concepts.
            I wholeheartedly recommend Chuks Chito for future opportunities in full-stack development. She is a valuable asset.
            For further information, please contact me at asuquondifreke06@gmail.com.
            </small>
        </SwiperSlide>
        <SwiperSlide className='testimonial'>
          <div className="client__avatar">
            <img src={Tonia} alt="person three"/>
          </div>
            <h5 className='client__name'>CEO,SkinLuxe</h5>
            <small className='client__review'>
            I am thrilled to provide this testimonial for Chuks Chito who did an excellent job designing our skincare shopping website. Their talent and expertise in frontend development have exceeded our expectations. The website is visually stunning, user-friendly, and performs flawlessly.
            Chuks Chito demonstrated exceptional understanding of user experience and visual design principles. Their professionalism, effective communication, and timely delivery made the entire process seamless. I highly recommend Chuks Chito anyone seeking a skilled frontend developer.
            For further information, please contact me at ofiliifeoma27@gmail.com.

            </small>
        </SwiperSlide>
      </Swiper>
    </section>
  )
}

export default Testimonials